import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import ReactHtmlParser from 'react-html-parser';
import TroubleTicketServiceWrapper from './TroubleTicketServiceWrapper';
import {getAccountDetails, getUserPermission} from "../../../../../../selectors";


class TroubleTicketServiceLines extends Component {

  state = {
    isPlanNoteCollapsed: false,
    isServiceLinesCollapsed: false,
    isPaginationDropdownOpen: false,
    pageActiveNumber: 1,
    pageShowingFrom: 0,
    pageShowingTo: 9,
    pageItemsCount: 10,
  };

  render() {
    const {
      isPlanNoteCollapsed,
      isServiceLinesCollapsed,
      pageShowingFrom,
      pageShowingTo,
    } = this.state;

    const {
      searchWord,
      serviceInfo,
      handleActiveDropDown,
      activeServiceLineDropdownId,
      handleProductAndPackagesClick,
      history,
      showHistoricalData,
    } = this.props;

    let pageItemsTotal = serviceInfo.serviceLines.length;

    let serviceLineNumberMatch = false;

    let hasActiveLines = false;

    for (const serviceLine of serviceInfo.serviceLines) {

      if (serviceLine.status === 'Active') {
        hasActiveLines = true;
        break;
      }
    }
    return (
      <div
        className={"plan-wrapper border-0 pt-0"
          + (isServiceLinesCollapsed ? "" : " plan-wrapper-expanded")
          + (serviceInfo.endDate ? " plan-wrapper-historical" : "")
        }
      >
        <div className="plan-body ">
          <div className={isPlanNoteCollapsed ? 'plan-details' : 'plan-details collapse'}>
            <div className="plan-description">{ReactHtmlParser(serviceInfo.planNote)}</div>
          </div>
          <div className={"services-wrapper mt-0" + (isServiceLinesCollapsed ? " d-none" : "")}>
            <div className="pagination-custom">
              <div className="pagination-results">
                 {/*check if we have a service line number match*/}
                {serviceInfo.serviceLines.map((service, index) => (
                  searchWord === service.number && (
                    serviceLineNumberMatch = true
                  )
                ))}
                {serviceInfo.serviceLines.map((service, index) => (
                  <Fragment>
                     {/*if we have a service line number match ...*/}
                    {serviceLineNumberMatch ? (
                      // ... only show matched line
                      searchWord === service.number && (
                        <>

                          <TroubleTicketServiceWrapper
                            key={service.serviceLineId}
                            service={service}
                            serviceLinesCount={pageItemsTotal}
                            serviceModel={serviceInfo.serviceModel}
                            directorySystemNumType={serviceInfo.serviceModel.directorySystemNumType.description}
                            accountPlanId={serviceInfo.accountPlanId}
                            planId={serviceInfo.planId}
                            handleActiveDropDown={handleActiveDropDown}
                            activeServiceLineDropdownId={activeServiceLineDropdownId}
                            handleProductAndPackagesClick={handleProductAndPackagesClick}
                            showAddEquipmentWizardHandler={this.props.showAddEquipmentWizardHandler}
                            showRemoveEquipmentWizardHandler={this.props.showRemoveEquipmentWizardHandler}
                            showSwapEquipmentWizardHandler={this.props.showSwapEquipmentWizardHandler}
                            showValidateServiceWizardHandler={this.props.showValidateServiceWizardHandler}
                            showHistoricalData={showHistoricalData}
                            history={history}
                          />
                        </>
                      )
                    ) : (

                      // ... otherwise show all items on current page
                      index >= pageShowingFrom && index <= pageShowingTo && (
                        <>

                          <TroubleTicketServiceWrapper
                            key={service.serviceLineId}
                            service={service}
                            serviceLinesCount={pageItemsTotal}
                            serviceModel={serviceInfo.serviceModel}
                            directorySystemNumType={serviceInfo.serviceModel.directorySystemNumType.description}
                            accountPlanId={serviceInfo.accountPlanId}
                            planId={serviceInfo.planId}
                            handleActiveDropDown={handleActiveDropDown}
                            activeServiceLineDropdownId={activeServiceLineDropdownId}
                            handleProductAndPackagesClick={handleProductAndPackagesClick}
                            showAddEquipmentWizardHandler={this.props.showAddEquipmentWizardHandler}
                            showRemoveEquipmentWizardHandler={this.props.showRemoveEquipmentWizardHandler}
                            showSwapEquipmentWizardHandler={this.props.showSwapEquipmentWizardHandler}
                            showValidateServiceWizardHandler={this.props.showValidateServiceWizardHandler}
                            showHistoricalData={showHistoricalData}
                            history={history}
                          />
                        </>
                      )
                    )}

                  </Fragment>
                ))}

              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const accountInfo = getAccountDetails(state).accountDetails.accountInfo,
    canViewServiceLines = getUserPermission(state, 'SERVICE_LINES', 'SERVICE_LINE_VIEW_LINES'),
    canEditServiceLinePlans = getUserPermission(state, 'SERVICE_LINES', 'SERVICE_LINE_CHANGE_PLAN'),
    canAddServiceLines = getUserPermission(state, 'SERVICE_LINES', 'SERVICE_LINE_ADD_SERVICE_LINE'),
    canRemoveServiceLines = getUserPermission(state, 'SERVICE_LINES', 'SERVICE_LINE_REMOVE_SERVICE_LINE'),
    canSuspendServiceLines = getUserPermission(state, 'SERVICE_LINES', 'SERVICE_LINE_SUSPEND_SERVICE_LINE');

  let serviceLinePermissions =
    [
      {canEditServiceLinePlans},
      {canAddServiceLines},
      {canRemoveServiceLines},
      {canSuspendServiceLines}
    ].filter((permission) => Object.values(permission)[0] === true)

  return {
    accountInfo,
    canViewServiceLines,
    canEditServiceLinePlans,
    canAddServiceLines,
    canRemoveServiceLines,
    canSuspendServiceLines,
    serviceLinePermissions
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(TroubleTicketServiceLines);
